
import { useState } from 'react';
import AppService, { Utilities } from "s2s-app-service";
import { processServiceErrorsToAlerts } from '../js/utilities';
import useAlerts from '../hooks/alerts';
import useAuth from "../hooks/auth";
import {
    LS_SECTION_KEYS,
    storeLocalData,
    retrieveLocalData,
} from './../js/localData';
const initialState = {};
const LS_SECTION_KEY = LS_SECTION_KEYS.CONTACTS;

const useContacts = () => {
  const [contactList, setContacts] = useState();
  const [currentContact, setCurrentContact] = useState();
  const [totalContacts, setTotalContacts] = useState();
  const [busyRetrievingContacts, setBusyRetrievingContacts] = useState(false);
  const [, { createErrorAlert }] = useAlerts();
  const [auth] = useAuth();

  const getContacts = async (searchFilter, limit = 20, offset = 0) => {
    // no call contacts availalbe, there is disconnected so get call Contacts Cahched
    if (auth.isOnline === false) {
      // Contacts Cahched is available 

      // Contacts Cahched is unavailable
      setContacts(retrieveLocalData(LS_SECTION_KEY, { items: [] }).items);
      return;
    }

    try {

      const filters = {};
      if (searchFilter && searchFilter.length > 0) {
        filters['search'] = searchFilter;
      }

      if (busyRetrievingContacts === false && auth.isOnline) {

        setBusyRetrievingContacts(true);

        const myContactData = await AppService.getInstance().speak('listContacts', {
          "offset": offset,
          "limit": limit,
          "filters": filters
        });

        // console.log('MY CONTACT DATA', myContactData);
        if (typeof myContactData.metadata !== "undefined" && typeof myContactData.metadata.total !== "undefined") {
          setTotalContacts(myContactData.metadata.total);
        } else {
          console.error('No Metadata or total in contact data returned from API', myContactData);
        }

        const contacts = offset === 0 ? myContactData.items : contactList.concat(myContactData.items);
        setContacts(contacts);

        storeLocalData(LS_SECTION_KEY, { items: contacts });
        setBusyRetrievingContacts(false);
      }
    } catch (e) {
      setBusyRetrievingContacts(false);

      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }
  };

  const getContactDataByPhoneNumber = async (number) => {
    try {
      let response = {
        items: [],
        metadata: {
          total: 0,
          offset: 0,
          count: 0,
          limit: 1,
        },
      };
      if(auth.isOnline){
        const filters = number ? { search: number } : {};

        response = await AppService.getInstance().speak('listContacts', {
          offset: 0,
          limit: 1,
          filters,
        });
      }
      return response;
      
    } catch (e) {
      console.error('Error getting contact data by phone number', e);

      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }
  };


  const getContact = async (uuid) => {
    //console.log("getContact uuid", uuid);

    try {
      if(auth.isOnline){
        let myContactData;
        if (uuid && uuid !== "new") {
          myContactData = await AppService.getInstance().speak('getContact', {
            "contact_uuid": uuid,
          });
        }

        setCurrentContact(myContactData);
      }
    } catch (e) {
      console.error('Error getting a contact', e);

      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }
  };

  const deleteContact = async (uuid, history) => {
    try {
      if(auth.isOnline){
        if (uuid && uuid !== "new") {
          await AppService.getInstance().speak('deleteContact', {
            "contact_uuid": uuid,
          });
        }

        setCurrentContact(undefined);
        history.goBack();
      }
    } catch (e) {
      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }
  };

  const addContact = async (contact) => {
    //console.log('CONTACTS HOOK -------> addContact(contact)', contact);
    try {
      if(auth.isOnline){
        await AppService.getInstance().speak('createUserContact', {
          "contact_data": contact,
          "body": contact
        });
      }
    } catch (e) {
      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }
  };

  const updateContact = async (contact) => {
    //console.log('CONTACTS HOOK -------> updateContact(contact, history)', contact, history);
    try {
      if(auth.isOnline){
        await AppService.getInstance().speak('updateContact', {
          "contact_uuid": contact.uuid,
          "body": contact
        });
      }
    } catch (e) {
      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(Utilities.formatError(e));

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 10,
      });
    }
  };
  return [contactList, currentContact, totalContacts, { getContacts, getContact, deleteContact, addContact, updateContact, getContactDataByPhoneNumber }];
};

export default useContacts;
export { initialState };
